var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBcReportFooter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1090,
    height: 140,
    viewBox: "0 0 1090 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_26_518)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1090,
    height: 140,
    fill: "#FF3057"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1090,
    height: 140,
    fill: "url(#pattern0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1090 -0.5C1090 -0.5 427.126 -2.41399e-06 356.27 1.20401e-05C285.413 2.65241e-05 323.133 140 214.633 140L1090 140L1090 -0.5Z",
    fill: "#F8F7FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1090 -0.5C1090 -0.5 427.126 -2.41399e-06 356.27 1.20401e-05C285.413 2.65241e-05 323.133 140 214.633 140L1090 140L1090 -0.5Z",
    fill: "url(#pattern1)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 0.0216667,
    height: 0.185714
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_26_518",
    transform: "scale(0.000833333 0.00714286)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern1",
    patternContentUnits: "objectBoundingBox",
    width: 0.026185,
    height: 0.185053
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_26_518",
    transform: "scale(0.00100711 0.00711744)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern2",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image1_26_518",
    transform: "scale(0.000390625 0.00197239)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_26_518"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1090,
    height: 140,
    fill: "white"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_26_518",
    width: 26,
    height: 26,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAaCAQAAAADQ4RFAAABEklEQVR4Ac2Sr47DMAyHzUdGhkZKQopCSoZG8nR7iPHRgUhRpXZaHuz0ycr5/uhHTydrU9PPnj3ns17ux3V+X3v5Gpw1sfuxl9+Id5rYOq/z95f70suWW4Lw9LOkJXtf/bduh8fpeSZ6aamlLUO2zKlOg/jIxgMlvTzP60xSnUh8XZy0xBsIGWRu2RzRhVH4eBpDEnWqUxAyP4u8yxiMM9+CRJGDMRhnSaLI2wOjkyI2llwn2r8uACYfRaQNQhb/1mJHEb6jOHnEXo1bon3cxuN0OwwX8CJukGnINoC335ctj8AFJ+xuxL74kH8orNZSq2xaS62yaS21yqa11Cr/d2G1llpl01pqlU1rqVU2raVW+QN0FoE7TK1N4wAAAABJRU5ErkJggg=="
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBcReportFooter);
export default __webpack_public_path__ + "static/media/bc-report-footer.92e61a3d119afc82000fbe0d6159543b.svg";
export { ForwardRef as ReactComponent };